/** Auth0 M2M scope list — mirrors server/domain/adapters/auth0/auth0Scopes.js */

/** @type {{ scope: string, tier: "required" | "recommended", label: string }[]} */
export const AUTH0_SCOPE_CONFIG = [
  { scope: "read:tenant_settings", tier: "required", label: "Tenant settings" },
  { scope: "read:clients", tier: "required", label: "Applications (clients)" },
  { scope: "read:connections", tier: "required", label: "Connections" },
  { scope: "read:users", tier: "required", label: "Users" },
  { scope: "read:roles", tier: "required", label: "Roles" },
  { scope: "read:rules", tier: "required", label: "Rules (legacy)" },
  { scope: "read:actions", tier: "required", label: "Actions" },
  { scope: "read:logs", tier: "required", label: "Logs" },
  { scope: "read:attack_protection", tier: "required", label: "Attack protection" },
  { scope: "read:custom_domains", tier: "required", label: "Custom domains" },
  { scope: "read:email_provider", tier: "required", label: "Email provider" },
  { scope: "read:guardian_factors", tier: "recommended", label: "Tenant MFA factors" },
  { scope: "read:authentication_methods", tier: "recommended", label: "Per-user MFA methods" },
  { scope: "read:role_members", tier: "recommended", label: "Role members" },
];

export const AUTH0_REQUIRED_SCOPE_COUNT = AUTH0_SCOPE_CONFIG.filter((s) => s.tier === "required").length;

/**
 * @param {string[]} granted
 * @param {{ scope: string, granted: boolean, tier: string }[] | undefined} scopeStatus
 */
export function resolveAuth0ScopeRows(granted, scopeStatus) {
  if (Array.isArray(scopeStatus) && scopeStatus.length > 0) {
    return scopeStatus.map((row) => ({
      scope: row.scope,
      tier: row.tier === "recommended" ? "recommended" : "required",
      granted: Boolean(row.granted),
      label: AUTH0_SCOPE_CONFIG.find((c) => c.scope === row.scope)?.label || row.scope,
    }));
  }
  const set = new Set(Array.isArray(granted) ? granted : []);
  return AUTH0_SCOPE_CONFIG.map((row) => ({
    ...row,
    granted: set.has(row.scope),
  }));
}
